<template>
    <div class="cf-tela">
        <div class="cf-cabecalho">
            <div>
                <h3 class="cf-cabecalho__titulo">{{ titulo }}</h3>
                <p class="cf-cabecalho__sub">Configuração financeira das ofertas: tipos de parcela, contas e eventos usados ao enviar inscrições e matrículas ao ERP.</p>
            </div>
            <div class="cf-cabecalho__acoes">
                <button type="button" class="btn btn-outline-primary" :disabled="sincronizando || atualizandoListas" @click.prevent="sincronizarTudo()" title="Busca novamente no ERP/CRM os eventos, tipos e situações de parcela, contas bancárias, tipos de evento e campos personalizados">
                    <span v-if="sincronizando || atualizandoListas" class="spinner-border spinner-border-sm mr-1" aria-hidden="true"></span>
                    <b-icon v-else icon="arrow-repeat"></b-icon>
                    {{ sincronizando || atualizandoListas ? 'Sincronizando...' : 'Sincronizar com ERP/CRM' }}
                </button>
                <small class="cf-cabecalho__sincronia" role="status">
                    <template v-if="atualizandoListas"><span class="spinner-grow spinner-grow-sm" aria-hidden="true"></span> Atualizando listas do ERP/CRM...</template>
                    <template v-else-if="sincronizadoEm">Listas atualizadas {{ quando(sincronizadoEm) }}</template>
                    <template v-else>Listas ainda não sincronizadas com o ERP/CRM</template>
                </small>
            </div>
        </div>

        <!-- listas que não vieram do ERP/CRM: sem isso os campos apareceriam vazios sem explicação -->
        <div v-if="falhasIntegracao.length" class="cf-alerta" role="alert">
            <b-icon icon="exclamation-triangle-fill" class="cf-alerta__icone" aria-hidden="true"></b-icon>
            <div class="cf-alerta__texto">
                <strong>Não foi possível carregar algumas listas do ERP/CRM.</strong>
                <ul class="cf-alerta__lista">
                    <li v-for="falha in falhasIntegracao" :key="falha.mensagem">
                        {{ falha.listas.join(', ') }}: <span class="cf-alerta__erro">{{ falha.mensagem }}</span>
                    </li>
                </ul>
                <small>Os valores já salvos continuam valendo; as listas mostram o que foi gravado na última sincronização (ou "Código ... (salvo)" quando o item não está nela).</small>
            </div>
            <button type="button" class="btn btn-sm btn-outline-danger cf-alerta__acao" :disabled="atualizandoListas" @click="atualizarListas(true)">
                <span v-if="atualizandoListas" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                <b-icon v-else icon="arrow-clockwise"></b-icon> Tentar novamente
            </button>
        </div>

        <ul class="nav nav-tabs" id="cfTab" role="tablist">
            <li v-for="aba in abas" :key="aba.id" class="nav-item">
                <a class="nav-link" :class="{ active: aba.id === 'gerais' }" :id="aba.id + '-tab'" data-toggle="tab" :href="'#' + aba.id" role="tab" :aria-controls="aba.id" :aria-selected="aba.id === 'gerais' ? 'true' : 'false'">
                    <b-icon :icon="aba.icone"></b-icon> {{ aba.titulo }}
                    <span v-if="pendenciasAba(aba).length" class="cf-aba-selo cf-aba-selo--pendente" :title="pendenciasAba(aba).length + ' pendência(s)'">{{ pendenciasAba(aba).length }}</span>
                    <b-icon v-else icon="check-circle-fill" class="cf-aba-ok" title="Configurado"></b-icon>
                    <span v-if="abaAlterada(aba)" class="cf-aba-alterada" title="Alterações não salvas" aria-label="Alterações não salvas"></span>
                </a>
            </li>
        </ul>
        <div class="tab-content pt-3" id="cfTabContent">
            <!-- ================= Gerais ================= -->
            <div class="tab-pane fade show active" id="gerais" role="tabpanel" aria-labelledby="gerais-tab">
                <form id="form-gerais" name="form-gerais" @submit.prevent novalidate>
                    <div>
                        <slot name="csrf">

                        </slot>
                    </div>
                    <input type="hidden" name="id_empresa">

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="bell"></b-icon> Disparo do evento "valor da matrícula"</legend>
                        <p class="ec-form-secao__descricao">Evento do CRM disparado com o valor da matrícula e a etapa da inscrição em que ele é enviado.</p>
                        <div class="form-row">
                            <div class="form-group col-lg-4">
                                <label for="tipoeventocrm">Tipo de evento (CRM)</label>
                                <select id="tipoeventocrm" name="tipoeventocrm" class="custom-select" :class="{ 'cf-faltando': falta(tipo_evento_aviso_valor_matricula_selecionado) }" v-model="tipo_evento_aviso_valor_matricula_selecionado">
                                    <option :value="0">Selecione o tipo de evento</option>
                                    <option v-if="foraDaLista(configuracao_unidade_inscricao.lista_tipo_evento_crm, tipo_evento_aviso_valor_matricula_selecionado, 'idcrm')" :value="tipo_evento_aviso_valor_matricula_selecionado">Código {{ tipo_evento_aviso_valor_matricula_selecionado }} (salvo)</option>
                                    <option v-for="tipo_evento_crm in lista(configuracao_unidade_inscricao.lista_tipo_evento_crm)" :key="tipo_evento_crm.idcrm" :value="tipo_evento_crm.idcrm">{{ tipo_evento_crm.titulo }}</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="camposPersonalizadoValor">Campo personalizado (CRM)</label>
                                <select class="custom-select" name="camposPersonalizadoValor" id="camposPersonalizadoValor" :class="{ 'cf-faltando': falta(custom_field_selecionado) }" v-model="custom_field_selecionado">
                                    <option :value="0">Selecione o campo personalizado</option>
                                    <option v-if="foraDaLista(configuracao_unidade_inscricao.lista_campos_personalizados, custom_field_selecionado, 'id')" :value="custom_field_selecionado">Código {{ custom_field_selecionado }} (salvo)</option>
                                    <option v-for="campo in lista(configuracao_unidade_inscricao.lista_campos_personalizados)" :key="campo.id" :value="campo.id">{{ campo.nome }} ({{ campo.coluna }})</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="etapaDisparoValor">Etapa de disparo</label>
                                <select class="custom-select" name="etapaDisparoValor" id="etapaDisparoValor" :class="{ 'cf-faltando': falta(etapa_selecionada) }" v-model="etapa_selecionada">
                                    <option :value="0">Selecione a etapa</option>
                                    <option v-for="etapa in etapasDisparo" :key="etapa.valor" :value="etapa.valor">{{ etapa.titulo }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="cf-acoes-secao">
                            <situacao-secao :pendencias="pendencias('valor')" :alterada="alterada('valor')"></situacao-secao>
                            <button v-if="alterada('valor')" type="button" class="btn btn-link btn-sm" :disabled="!!salvando.valor" @click="desfazer('valor')">Desfazer</button>
                            <button type="button" class="btn btn-primary btn-sm" :disabled="!alterada('valor') || !!salvando.valor" @click.prevent="salvarConfiguracaoDisparoEventoCRM()">
                                <span v-if="salvando.valor" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <b-icon v-else icon="check2"></b-icon> Salvar disparo
                            </button>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao">
                        <legend><b-icon icon="person-check"></b-icon> Matrícula do inscrito</legend>
                        <p class="ec-form-secao__descricao">Evento do CRM disparado quando o inscrito é matriculado.</p>
                        <div class="form-row">
                            <div class="form-group col-lg-4">
                                <label for="tipoeventocrmMatricula">Tipo de evento (CRM)</label>
                                <select id="tipoeventocrmMatricula" name="tipoeventocrmMatricula" class="custom-select" :class="{ 'cf-faltando': falta(tipo_evento_aviso_matricula_selecionado) }" v-model="tipo_evento_aviso_matricula_selecionado">
                                    <option :value="0">Selecione o tipo de evento</option>
                                    <option v-if="foraDaLista(configuracao_unidade_inscricao.lista_tipo_evento_crm, tipo_evento_aviso_matricula_selecionado, 'idcrm')" :value="tipo_evento_aviso_matricula_selecionado">Código {{ tipo_evento_aviso_matricula_selecionado }} (salvo)</option>
                                    <option v-for="tipo_evento_crm in lista(configuracao_unidade_inscricao.lista_tipo_evento_crm)" :key="tipo_evento_crm.idcrm" :value="tipo_evento_crm.idcrm">{{ tipo_evento_crm.titulo }}</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="camposPersonalizadoMatricula">Campo personalizado (CRM)</label>
                                <select class="custom-select" name="camposPersonalizadoMatricula" id="camposPersonalizadoMatricula" :class="{ 'cf-faltando': falta(custom_field_matricula_selecionado) }" v-model="custom_field_matricula_selecionado">
                                    <option :value="0">Selecione o campo personalizado</option>
                                    <option v-if="foraDaLista(configuracao_unidade_inscricao.lista_campos_personalizados, custom_field_matricula_selecionado, 'id')" :value="custom_field_matricula_selecionado">Código {{ custom_field_matricula_selecionado }} (salvo)</option>
                                    <option v-for="campo in lista(configuracao_unidade_inscricao.lista_campos_personalizados)" :key="campo.id" :value="campo.id">{{ campo.nome }} ({{ campo.coluna }})</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="etapaDisparoMatricula">Etapa de disparo</label>
                                <select class="custom-select" name="etapaDisparoMatricula" id="etapaDisparoMatricula" :class="{ 'cf-faltando': falta(etapa_matricula_selecionada) }" v-model="etapa_matricula_selecionada">
                                    <option :value="0">Selecione a etapa</option>
                                    <option v-for="etapa in etapasDisparo" :key="etapa.valor" :value="etapa.valor">{{ etapa.titulo }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="cf-acoes-secao">
                            <situacao-secao :pendencias="pendencias('matriculaInscrito')" :alterada="alterada('matriculaInscrito')"></situacao-secao>
                            <button v-if="alterada('matriculaInscrito')" type="button" class="btn btn-link btn-sm" :disabled="!!salvando.matriculaInscrito" @click="desfazer('matriculaInscrito')">Desfazer</button>
                            <button type="button" class="btn btn-primary btn-sm" :disabled="!alterada('matriculaInscrito') || !!salvando.matriculaInscrito" @click.prevent="salvarConfiguracaoDisparoEventoMatriculaCRM()">
                                <span v-if="salvando.matriculaInscrito" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <b-icon v-else icon="check2"></b-icon> Salvar matrícula
                            </button>
                        </div>
                    </fieldset>
                </form>
            </div>

            <!-- ================= Taxa de inscrição ================= -->
            <div class="tab-pane fade" id="inscricao" role="tabpanel" aria-labelledby="inscricao-tab">
                <form id="form-inscricao" name="form-inscricao" @submit.prevent novalidate>
                    <div>
                        <slot name="csrf">

                        </slot>
                    </div>
                    <input type="hidden" name="id_empresa">

                    <fieldset class="ec-form-secao">
                        <legend><span class="cf-passo">1</span> Parcela da taxa de inscrição</legend>
                        <div class="form-row">
                            <div class="form-group col-lg-4">
                                <label for="tipoParcelaInscricao">Tipo de parcela</label>
                                <select id="tipoParcelaInscricao" name="tipoParcelaInscricao" class="custom-select" :class="{ 'cf-faltando': falta(codigotipoparcela_inscricao_selecionado) }" v-model="codigotipoparcela_inscricao_selecionado">
                                    <option :value="0">Selecione o tipo de parcela</option>
                                    <option v-if="foraDaLista(configuracao_unidade_inscricao.tipos_parcela, codigotipoparcela_inscricao_selecionado, 'CODIGOTIPOPARCELA')" :value="codigotipoparcela_inscricao_selecionado">Código {{ codigotipoparcela_inscricao_selecionado }} (salvo)</option>
                                    <option v-for="parcela_tipo_inscricao in lista(configuracao_unidade_inscricao.tipos_parcela)" :key="parcela_tipo_inscricao.CODIGOTIPOPARCELA" :value="parcela_tipo_inscricao.CODIGOTIPOPARCELA">{{ parcela_tipo_inscricao.DESCRICAO }}</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="situacaoParcelaInscricao">Situação de parcela paga</label>
                                <select id="situacaoParcelaInscricao" name="situacaoParcelaInscricao" class="custom-select" :class="{ 'cf-faltando': falta(codigosituacaoparcela_inscricao_selecionado) }" v-model="codigosituacaoparcela_inscricao_selecionado">
                                    <option :value="0">Selecione a situação</option>
                                    <option v-if="foraDaLista(configuracao.inscricao.situacoes_parcela, codigosituacaoparcela_inscricao_selecionado, 'codigosituacaoparcela')" :value="codigosituacaoparcela_inscricao_selecionado">Código {{ codigosituacaoparcela_inscricao_selecionado }} (salvo)</option>
                                    <option v-for="situacao_parcela in lista(configuracao.inscricao.situacoes_parcela)" :key="situacao_parcela.codigosituacaoparcela" :value="situacao_parcela.codigosituacaoparcela">{{ situacao_parcela.descricao }}</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="codigobancocontainscricao">Conta bancária de liquidação (ERP)</label>
                                <select id="codigobancocontainscricao" name="codigobancocontainscricao" class="custom-select" :class="{ 'cf-faltando': falta(codigobancoconta_inscricao_selecionado) }" v-model="codigobancoconta_inscricao_selecionado">
                                    <option :value="0">Selecione a conta bancária</option>
                                    <option v-if="foraDaLista(configuracao.inscricao.lista_contas, codigobancoconta_inscricao_selecionado, 'codigobancoconta')" :value="codigobancoconta_inscricao_selecionado">Código {{ codigobancoconta_inscricao_selecionado }} (salvo)</option>
                                    <option v-for="conta in lista(configuracao.inscricao.lista_contas)" :key="conta.codigobancoconta" :value="conta.codigobancoconta">{{ conta.descricaocontabancaria }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="cf-acoes-secao">
                            <situacao-secao :pendencias="pendencias('parcelaInsc')" :alterada="alterada('parcelaInsc')"></situacao-secao>
                            <button v-if="alterada('parcelaInsc')" type="button" class="btn btn-link btn-sm" :disabled="!!salvando.parcelaInsc" @click="desfazer('parcelaInsc')">Desfazer</button>
                            <button type="button" class="btn btn-primary btn-sm" :disabled="!alterada('parcelaInsc') || !!salvando.parcelaInsc" @click.prevent="salvarCodigoTipoParcelaInscricao()">
                                <span v-if="salvando.parcelaInsc" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <b-icon v-else icon="check2"></b-icon> Salvar parcela
                            </button>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao" :disabled="!(codigotipoparcela_inscricao_selecionado>0)">
                        <legend><span class="cf-passo">2</span> Eventos da parcela</legend>
                        <p class="ec-form-secao__descricao" v-if="!(codigotipoparcela_inscricao_selecionado>0)">Selecione o tipo de parcela no passo 1 para configurar os eventos.</p>
                        <template v-else>
                            <div class="cf-busca-eventos">
                                <b-icon icon="search" class="cf-busca-eventos__icone" aria-hidden="true"></b-icon>
                                <input type="search" class="form-control form-control-sm" v-model="buscaEventosInscricao" placeholder="Buscar evento por nome ou Id nas listas abaixo" aria-label="Buscar evento nas listas de eventos da inscrição">
                                <small v-if="buscaEventosInscricao" class="cf-busca-eventos__info">{{ totalEventosEncontrados(buscaEventosInscricao) }} evento(s) encontrado(s)</small>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-lg-4">
                                    <label for="listaEventosInscricao">Evento</label>
                                    <select id="listaEventosInscricao" name="listaEventosInscricao" class="custom-select" :class="{ 'cf-faltando': falta(id_eventoselecionado_inscricao) }" v-model="id_eventoselecionado_inscricao">
                                        <option :value="0">Selecione um evento</option>
                                        <optgroup v-for="grupo in gruposVisiveis(configuracao_unidade_inscricao.tipos_evento, configuracao_unidade_inscricao.lista_eventos, buscaEventosInscricao, id_eventoselecionado_inscricao)" :key="grupo.descricaotipoevento" :label="grupo.descricaotipoevento">
                                            <option v-for="evento in eventosDoGrupo(configuracao_unidade_inscricao.lista_eventos, grupo, buscaEventosInscricao, id_eventoselecionado_inscricao)" :key="evento.idevento" :value="evento.idevento">{{ evento.descricaoevento }} (Id: {{ evento.idevento }})</option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div class="form-group col-lg-4">
                                    <label for="listaEventosdescontosInscricao">Desconto (cupom) <small class="text-muted">opcional</small></label>
                                    <select id="listaEventosdescontosInscricao" name="listaEventosdescontosInscricao" class="custom-select" v-model="id_evento_desc_selecionado_inscricao">
                                        <option :value="0">Nenhum</option>
                                        <optgroup v-for="grupo in gruposVisiveis(configuracao_unidade_inscricao.tipos_evento_desc, configuracao_unidade_inscricao.lista_eventos_desconto, buscaEventosInscricao, id_evento_desc_selecionado_inscricao)" :key="grupo.descricaotipoevento" :label="grupo.descricaotipoevento">
                                            <option v-for="evento in eventosDoGrupo(configuracao_unidade_inscricao.lista_eventos_desconto, grupo, buscaEventosInscricao, id_evento_desc_selecionado_inscricao)" :key="evento.idevento" :value="evento.idevento">{{ evento.descricaoevento }} (Id: {{ evento.idevento }})</option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div class="form-group col-lg-4">
                                    <label for="listaEventosServicosInscricao">Evento de serviço <small class="text-muted">opcional</small></label>
                                    <select id="listaEventosServicosInscricao" name="listaEventosServicosInscricao" class="custom-select" v-model="id_evento_desc_servico_inscricao">
                                        <option :value="0">Nenhum</option>
                                        <optgroup v-for="grupo in gruposVisiveis(configuracao_unidade_inscricao.tipos_evento_desc, configuracao_unidade_inscricao.lista_eventos_desconto, buscaEventosInscricao, id_evento_desc_servico_inscricao)" :key="grupo.descricaotipoevento" :label="grupo.descricaotipoevento">
                                            <option v-for="evento in eventosDoGrupo(configuracao_unidade_inscricao.lista_eventos_desconto, grupo, buscaEventosInscricao, id_evento_desc_servico_inscricao)" :key="evento.idevento" :value="evento.idevento">{{ evento.descricaoevento }} (Id: {{ evento.idevento }})</option>
                                        </optgroup>
                                    </select>
                                </div>
                            </div>
                            <div class="cf-acoes-secao">
                                <situacao-secao :pendencias="pendencias('eventosInsc')" :alterada="alterada('eventosInsc')"></situacao-secao>
                                <button v-if="alterada('eventosInsc')" type="button" class="btn btn-link btn-sm" :disabled="!!salvando.eventosInsc" @click="desfazer('eventosInsc')">Desfazer</button>
                                <button v-if="configuracao_unidade_inscricao.eventos_configurados.length>0" type="button" class="btn btn-outline-danger btn-sm" :disabled="!!salvando.eventosInsc" @click.prevent="removerEventosInscricao()"><b-icon icon="trash"></b-icon> Remover eventos</button>
                                <button type="button" class="btn btn-primary btn-sm" :disabled="!(configuracao_evento_inscricao.evento_id>0) || !alterada('eventosInsc') || !!salvando.eventosInsc" @click.prevent="adicionarEventoConfUnidadeInscricao()">
                                    <span v-if="salvando.eventosInsc" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <b-icon v-else icon="check2"></b-icon> {{ configuracao_unidade_inscricao.eventos_configurados.length>0 ? 'Salvar alterações' : 'Salvar eventos' }}
                                </button>
                            </div>
                        </template>
                    </fieldset>
                </form>
            </div>

            <!-- ================= Taxa de matrícula ================= -->
            <div class="tab-pane fade" id="matricula" role="tabpanel" aria-labelledby="matricula-tab">
                <form id="form-matricula" name="form-matricula" @submit.prevent novalidate>
                    <div>
                        <slot name="csrf">

                        </slot>
                    </div>
                    <input type="hidden" name="id_empresa">

                    <fieldset class="ec-form-secao">
                        <legend><span class="cf-passo">1</span> Parcela da taxa de matrícula</legend>
                        <div class="form-row">
                            <div class="form-group col-lg-4">
                                <label for="tipoParcelaMatricula">Tipo de parcela</label>
                                <select id="tipoParcelaMatricula" name="tipoParcelaMatricula" class="custom-select" :class="{ 'cf-faltando': falta(codigotipoparcela_matricula_selecionado) }" v-model="codigotipoparcela_matricula_selecionado">
                                    <option :value="0">Selecione o tipo de parcela</option>
                                    <option v-if="foraDaLista(configuracao_unidade_matricula.tipos_parcela, codigotipoparcela_matricula_selecionado, 'CODIGOTIPOPARCELA')" :value="codigotipoparcela_matricula_selecionado">Código {{ codigotipoparcela_matricula_selecionado }} (salvo)</option>
                                    <option v-for="parcela_tipo_matricula in lista(configuracao_unidade_matricula.tipos_parcela)" :key="parcela_tipo_matricula.CODIGOTIPOPARCELA" :value="parcela_tipo_matricula.CODIGOTIPOPARCELA">{{ parcela_tipo_matricula.DESCRICAO }}</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="situacaoParcelaMatricula">Situação de parcela paga</label>
                                <select id="situacaoParcelaMatricula" name="situacaoParcelaMatricula" class="custom-select" :class="{ 'cf-faltando': falta(codigosituacaoparcela_matricula_selecionado) }" v-model="codigosituacaoparcela_matricula_selecionado">
                                    <option :value="0">Selecione a situação</option>
                                    <option v-if="foraDaLista(configuracao.matricula.situacoes_parcela, codigosituacaoparcela_matricula_selecionado, 'codigosituacaoparcela')" :value="codigosituacaoparcela_matricula_selecionado">Código {{ codigosituacaoparcela_matricula_selecionado }} (salvo)</option>
                                    <option v-for="situacao_parcela in lista(configuracao.matricula.situacoes_parcela)" :key="situacao_parcela.codigosituacaoparcela" :value="situacao_parcela.codigosituacaoparcela">{{ situacao_parcela.descricao }}</option>
                                </select>
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="codigobancoconta">Conta bancária de liquidação (ERP)</label>
                                <select id="codigobancoconta" name="codigobancoconta" class="custom-select" :class="{ 'cf-faltando': falta(codigobancoconta_matricula_selecionado) }" v-model="codigobancoconta_matricula_selecionado">
                                    <option :value="0">Selecione a conta bancária</option>
                                    <option v-if="foraDaLista(configuracao.matricula.lista_contas, codigobancoconta_matricula_selecionado, 'codigobancoconta')" :value="codigobancoconta_matricula_selecionado">Código {{ codigobancoconta_matricula_selecionado }} (salvo)</option>
                                    <option v-for="conta in lista(configuracao.matricula.lista_contas)" :key="conta.codigobancoconta" :value="conta.codigobancoconta">{{ conta.descricaocontabancaria }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="cf-acoes-secao">
                            <situacao-secao :pendencias="pendencias('parcelaMat')" :alterada="alterada('parcelaMat')"></situacao-secao>
                            <button v-if="alterada('parcelaMat')" type="button" class="btn btn-link btn-sm" :disabled="!!salvando.parcelaMat" @click="desfazer('parcelaMat')">Desfazer</button>
                            <button type="button" class="btn btn-primary btn-sm" :disabled="!alterada('parcelaMat') || !!salvando.parcelaMat" @click.prevent="salvarCodigoTipoParcelaMatricula()">
                                <span v-if="salvando.parcelaMat" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <b-icon v-else icon="check2"></b-icon> Salvar parcela
                            </button>
                        </div>
                    </fieldset>

                    <fieldset class="ec-form-secao" :disabled="!(codigotipoparcela_matricula_selecionado>0)">
                        <legend><span class="cf-passo">2</span> Eventos da parcela</legend>
                        <p class="ec-form-secao__descricao" v-if="!(codigotipoparcela_matricula_selecionado>0)">Selecione o tipo de parcela no passo 1 para configurar os eventos.</p>
                        <template v-else>
                            <div class="cf-busca-eventos">
                                <b-icon icon="search" class="cf-busca-eventos__icone" aria-hidden="true"></b-icon>
                                <input type="search" class="form-control form-control-sm" v-model="buscaEventosMatricula" placeholder="Buscar evento por nome ou Id nas listas abaixo" aria-label="Buscar evento nas listas de eventos da matrícula">
                                <small v-if="buscaEventosMatricula" class="cf-busca-eventos__info">{{ totalEventosEncontrados(buscaEventosMatricula) }} evento(s) encontrado(s)</small>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-sm-6 col-xl-3">
                                    <label for="listaEventosMatricula">Evento</label>
                                    <select id="listaEventosMatricula" name="listaEventosMatricula" class="custom-select" :class="{ 'cf-faltando': falta(id_eventoselecionado_matricula) }" v-model="id_eventoselecionado_matricula">
                                        <option :value="0">Selecione um evento</option>
                                        <optgroup v-for="grupo in gruposVisiveis(configuracao_unidade_matricula.tipos_evento, configuracao_unidade_matricula.lista_eventos, buscaEventosMatricula, id_eventoselecionado_matricula)" :key="grupo.descricaotipoevento" :label="grupo.descricaotipoevento">
                                            <option v-for="evento in eventosDoGrupo(configuracao_unidade_matricula.lista_eventos, grupo, buscaEventosMatricula, id_eventoselecionado_matricula)" :key="evento.idevento" :value="evento.idevento">{{ evento.descricaoevento }} (Id: {{ evento.idevento }})</option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div class="form-group col-sm-6 col-xl-3">
                                    <label for="listaEventosDescCupomMatricula">Desconto (cupom) <small class="text-muted">opcional</small></label>
                                    <select id="listaEventosDescCupomMatricula" name="listaEventosDescCupomMatricula" class="custom-select" v-model="id_evento_desc_cupom_selecionado_matricula">
                                        <option :value="0">Nenhum</option>
                                        <optgroup v-for="grupo in gruposVisiveis(configuracao_unidade_matricula.tipos_evento_desc, configuracao_unidade_matricula.lista_eventos_desconto, buscaEventosMatricula, id_evento_desc_cupom_selecionado_matricula)" :key="grupo.descricaotipoevento" :label="grupo.descricaotipoevento">
                                            <option v-for="evento in eventosDoGrupo(configuracao_unidade_matricula.lista_eventos_desconto, grupo, buscaEventosMatricula, id_evento_desc_cupom_selecionado_matricula)" :key="evento.idevento" :value="evento.idevento">{{ evento.descricaoevento }} (Id: {{ evento.idevento }})</option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div class="form-group col-sm-6 col-xl-3">
                                    <label for="listaEventosDescGeralMatricula">Desconto (geral) <small class="text-muted">opcional</small></label>
                                    <select id="listaEventosDescGeralMatricula" name="listaEventosDescGeralMatricula" class="custom-select" v-model="id_evento_desc_geral_selecionado_matricula">
                                        <option :value="0">Nenhum</option>
                                        <optgroup v-for="grupo in gruposVisiveis(configuracao_unidade_matricula.tipos_evento_desc, configuracao_unidade_matricula.lista_eventos_desconto, buscaEventosMatricula, id_evento_desc_geral_selecionado_matricula)" :key="grupo.descricaotipoevento" :label="grupo.descricaotipoevento">
                                            <option v-for="evento in eventosDoGrupo(configuracao_unidade_matricula.lista_eventos_desconto, grupo, buscaEventosMatricula, id_evento_desc_geral_selecionado_matricula)" :key="evento.idevento" :value="evento.idevento">{{ evento.descricaoevento }} (Id: {{ evento.idevento }})</option>
                                        </optgroup>
                                    </select>
                                </div>
                                <div class="form-group col-sm-6 col-xl-3">
                                    <label for="listaEventosServicosMatricula">Evento de serviço <small class="text-muted">opcional</small></label>
                                    <select id="listaEventosServicosMatricula" name="listaEventosServicosMatricula" class="custom-select" v-model="id_evento_desc_servico_matricula">
                                        <option :value="0">Nenhum</option>
                                        <optgroup v-for="grupo in gruposVisiveis(configuracao_unidade_matricula.tipos_evento_desc, configuracao_unidade_matricula.lista_eventos_desconto, buscaEventosMatricula, id_evento_desc_servico_matricula)" :key="grupo.descricaotipoevento" :label="grupo.descricaotipoevento">
                                            <option v-for="evento in eventosDoGrupo(configuracao_unidade_matricula.lista_eventos_desconto, grupo, buscaEventosMatricula, id_evento_desc_servico_matricula)" :key="evento.idevento" :value="evento.idevento">{{ evento.descricaoevento }} (Id: {{ evento.idevento }})</option>
                                        </optgroup>
                                    </select>
                                </div>
                            </div>
                            <div class="cf-acoes-secao">
                                <situacao-secao :pendencias="pendencias('eventosMat')" :alterada="alterada('eventosMat')"></situacao-secao>
                                <button v-if="alterada('eventosMat')" type="button" class="btn btn-link btn-sm" :disabled="!!salvando.eventosMat" @click="desfazer('eventosMat')">Desfazer</button>
                                <button v-if="configuracao_unidade_matricula.eventos_configurados.length>0" type="button" class="btn btn-outline-danger btn-sm" :disabled="!!salvando.eventosMat" @click.prevent="removerEventosMatricula()"><b-icon icon="trash"></b-icon> Remover eventos</button>
                                <button type="button" class="btn btn-primary btn-sm" :disabled="!(configuracao_evento_matricula.evento_id>0 && configuracao_evento_matricula.valor>=0) || !alterada('eventosMat') || !!salvando.eventosMat" @click.prevent="adicionarEventoConfUnidadeMatricula()">
                                    <span v-if="salvando.eventosMat" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                    <b-icon v-else icon="check2"></b-icon> {{ configuracao_unidade_matricula.eventos_configurados.length>0 ? 'Salvar alterações' : 'Salvar eventos' }}
                                </button>
                            </div>
                        </template>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
// situação da seção ao lado dos botões: pendências, alterações não salvas ou "configurado"
const SituacaoSecao = {
    props: { pendencias: { type: Array, default: () => [] }, alterada: Boolean },
    template: `
        <span class="cf-situacao" :class="alterada ? 'cf-situacao--alterada' : (pendencias.length ? 'cf-situacao--pendente' : 'cf-situacao--ok')" role="status">
            <template v-if="alterada"><b-icon icon="pencil-fill"></b-icon> Alterações não salvas</template>
            <template v-else-if="pendencias.length"><b-icon icon="exclamation-circle-fill"></b-icon> Falta: {{ pendencias.join(', ') }}</template>
            <template v-else><b-icon icon="check-circle-fill"></b-icon> Configurado</template>
        </span>`,
};

// listas vindas do ERP/CRM: quando a consulta falha, o backend devolve a mensagem de erro no lugar da lista
const LISTAS_INTEGRACAO = [
    { chave: 'lista_tipo_evento_crm', rotulo: 'Tipos de evento do CRM', ler: c => c.inscricao.lista_tipo_evento_crm },
    { chave: 'lista_campos_personalizados', rotulo: 'Campos personalizados do CRM', ler: c => c.inscricao.lista_campos_personalizados },
    { chave: 'tipos_parcela', rotulo: 'Tipos de parcela', ler: c => c.inscricao.tipos_parcela },
    { chave: 'situacoes_parcela', rotulo: 'Situações de parcela', ler: c => c.inscricao.situacoes_parcela },
    { chave: 'lista_contas', rotulo: 'Contas bancárias', ler: c => c.inscricao.lista_contas },
    { chave: 'lista_eventos', rotulo: 'Eventos financeiros', ler: c => c.inscricao.lista_eventos },
];

// listas que a API de sincronização devolve e em quais blocos da configuração elas entram
const LISTAS_SINCRONIZADAS = {
    tipos_parcela: ['inscricao', 'matricula'],
    situacoes_parcela: ['inscricao', 'matricula'],
    lista_contas: ['inscricao', 'matricula'],
    lista_tipo_evento_crm: ['inscricao'],
    lista_campos_personalizados: ['inscricao'],
};

export default {
    components: { SituacaoSecao },
    props:['configuracao','unidade','titulo'],
    data(){
        return{
           etapasDisparo:[
               { valor:'inscricaoconfirmada', titulo:'Inscrição confirmada' },
               { valor:'contratoaceito',      titulo:'Contrato aceito' },
           ],
           abas:[
               { id:'gerais',    titulo:'Configurações gerais', icone:'sliders',    secoes:['valor', 'matriculaInscrito'] },
               { id:'inscricao', titulo:'Taxa de inscrição',    icone:'receipt',    secoes:['parcelaInsc', 'eventosInsc'] },
               { id:'matricula', titulo:'Taxa de matrícula',    icone:'cash-stack', secoes:['parcelaMat', 'eventosMat'] },
           ],
           // valores gravados de cada seção (para "Alterações não salvas" e "Desfazer")
           salvo:{},
           // seção sendo salva: { [secao]: true }
           salvando:{},
           sincronizando:false,
           // sincronização das listas do ERP/CRM (em segundo plano ao abrir a tela)
           atualizandoListas:false,
           errosIntegracao:{},
           sincronizadoEm:null,
           buscaEventosInscricao:'',
           buscaEventosMatricula:'',
           trocandoAba:false,
           custom_field_selecionado:null,
           custom_field_matricula_selecionado:null,
           tipo_evento_aviso_valor_matricula_selecionado:0,
           tipo_evento_aviso_matricula_selecionado:0,
           etapa_selecionada:0,
           etapa_matricula_selecionada:0,
           codigotipoparcela_inscricao_selecionado:0,
           codigosituacaoparcela_inscricao_selecionado:0,
           codigobancoconta_inscricao_selecionado:0,
           codigobancoconta_matricula_selecionado:0,
           configuracao_unidade_inscricao:null,
           id_eventoselecionado_inscricao:0,
           id_evento_desc_selecionado_inscricao:0,
           id_evento_desc_servico_inscricao:0,
           configuracao_evento_inscricao:{
                set_finances_unitie_id:null,
                unity_id:null,
                evento_id:null,
                evento_desconto_id:null,
                evento_servico_id:null,
                valor:0.00
           },
           codigotipoparcela_matricula_selecionado:0,
           codigosituacaoparcela_matricula_selecionado:0,
           configuracao_unidade_matricula:null,
           id_eventoselecionado_matricula:0,
           id_evento_desc_cupom_selecionado_matricula:0,
           id_evento_desc_geral_selecionado_matricula:0,
           id_evento_desc_servico_matricula:0,
           configuracao_evento_matricula:{
                set_finances_unitie_id:null,
                unity_id:null,
                evento_id:null,
                evento_desconto_id:null,
                evento_desconto_geral_id:null,
                evento_servico_id:null,
                valor:0.00
           }
        }
    },
    computed:{
        // falhas de integração agrupadas pela mensagem (normalmente é o mesmo erro para todas)
        falhasIntegracao(){
            const porMensagem = new Map()
            for(const item of LISTAS_INTEGRACAO){
                const valor = item.ler(this.configuracao)
                let mensagem = null
                if(this.errosIntegracao[item.chave]){
                    mensagem = this.semHtml(this.errosIntegracao[item.chave])
                }else if(!Array.isArray(valor) && !(valor && typeof valor === 'object')){
                    mensagem = this.semHtml(valor) || 'o ERP/CRM não devolveu a lista'
                }
                if(!mensagem) continue
                if(!porMensagem.has(mensagem)) porMensagem.set(mensagem, [])
                porMensagem.get(mensagem).push(item.rotulo)
            }
            return Array.from(porMensagem, ([mensagem, listas]) => ({ mensagem, listas }))
        },
        houveAlteracao(){
            return this.abas.some(aba => this.abaAlterada(aba))
        },
    },
    created(){
        const inscricao = this.configuracao.inscricao
        const matricula = this.configuracao.matricula
        const primeiro = lista => (lista && lista.length > 0 ? lista[0] : null)
        const idEvento = (configurado, relacao) => (configurado && configurado[relacao] ? configurado[relacao].idevento : 0)

        this.configuracao_unidade_inscricao = inscricao;
        this.configuracao_evento_inscricao.set_finances_unitie_id = inscricao.set_finances_unitie_id
        this.configuracao_evento_inscricao.unity_id = this.unidade.id
        this.codigotipoparcela_inscricao_selecionado = inscricao.codigotipoparcela || 0
        this.custom_field_selecionado = inscricao.custom_field || 0
        this.custom_field_matricula_selecionado = inscricao.custom_field_matricula || 0
        this.etapa_selecionada = inscricao.etapaenvioeventoaviso || 0
        this.etapa_matricula_selecionada = inscricao.etapaenvioeventoavisomatricula || 0
        this.tipo_evento_aviso_valor_matricula_selecionado = inscricao.tipo_evento_aviso_valor_matricula || 0
        this.tipo_evento_aviso_matricula_selecionado = inscricao.tipo_evento_aviso_matricula_inscrito || 0
        this.codigosituacaoparcela_inscricao_selecionado = inscricao.codigosituacaoparcela || 0
        this.codigobancoconta_inscricao_selecionado = inscricao.codigobancoconta || 0
        this.codigobancoconta_matricula_selecionado = matricula.codigobancoconta || 0

        const eventoInscricao = primeiro(inscricao.eventos_configurados)
        this.id_eventoselecionado_inscricao = idEvento(eventoInscricao, 'event')
        this.id_evento_desc_selecionado_inscricao = idEvento(eventoInscricao, 'event_discount')
        // cada relação é conferida por ela mesma (antes o serviço era lido quando havia desconto)
        this.id_evento_desc_servico_inscricao = idEvento(eventoInscricao, 'event_service')

        this.configuracao_unidade_matricula = matricula;
        this.configuracao_evento_matricula.set_finances_unitie_id = matricula.set_finances_unitie_id
        this.configuracao_evento_matricula.unity_id = this.unidade.id
        this.codigotipoparcela_matricula_selecionado = matricula.codigotipoparcela || 0
        this.codigosituacaoparcela_matricula_selecionado = matricula.codigosituacaoparcela || 0

        const eventoMatricula = primeiro(matricula.eventos_configurados)
        this.id_eventoselecionado_matricula = idEvento(eventoMatricula, 'event')
        this.id_evento_desc_cupom_selecionado_matricula = idEvento(eventoMatricula, 'event_discount')
        this.id_evento_desc_geral_selecionado_matricula = idEvento(eventoMatricula, 'event_discount_geral')
        this.id_evento_desc_servico_matricula = idEvento(eventoMatricula, 'event_service')

        for(const aba of this.abas) aba.secoes.forEach(secao => this.marcarSalvo(secao))
        this.sincronizadoEm = this.configuracao.integracao ? this.configuracao.integracao.sincronizado_em : null
    },
    mounted() {
        // aba pelo endereço (#inscricao / #matricula) e endereço atualizado ao trocar de aba
        const aba = this.abas.find(a => '#' + a.id === window.location.hash)
        if(aba) $('#' + aba.id + '-tab').tab('show')

        $(this.$el).on('show.bs.tab', 'a[data-toggle="tab"]', this.antesDeTrocarAba)
        $(this.$el).on('shown.bs.tab', 'a[data-toggle="tab"]', e => {
            history.replaceState(null, '', '#' + e.target.getAttribute('href').substring(1))
        })

        this.aoSairDaPagina = e => {
            if(!this.houveAlteracao) return
            e.preventDefault()
            e.returnValue = ''
        }
        window.addEventListener('beforeunload', this.aoSairDaPagina)

        // a tela abriu com as listas gravadas; se estiverem antigas, atualiza sem bloquear
        if(this.configuracao.integracao && this.configuracao.integracao.precisa_sincronizar){
            this.atualizarListas(false)
        }
    },
    beforeDestroy() {
        $(this.$el).off('show.bs.tab').off('shown.bs.tab')
        window.removeEventListener('beforeunload', this.aoSairDaPagina)
    },
    watch:{
        id_evento_desc_selecionado_inscricao(new_id){
            this.configuracao_evento_inscricao.evento_desconto_id = this.idInternoEvento(this.configuracao_unidade_inscricao.lista_eventos_desconto, new_id)
        },
        id_evento_desc_servico_inscricao(new_id){
            this.configuracao_evento_inscricao.evento_servico_id = this.idInternoEvento(this.configuracao_unidade_inscricao.lista_eventos_desconto, new_id)
        },
        id_eventoselecionado_inscricao(new_id){
            this.configuracao_evento_inscricao.evento_id = this.idInternoEvento(this.configuracao_unidade_inscricao.lista_eventos, new_id)
        },
        id_evento_desc_servico_matricula(new_id){
            this.configuracao_evento_matricula.evento_servico_id = this.idInternoEvento(this.configuracao_unidade_matricula.lista_eventos_desconto, new_id)
        },
        id_evento_desc_cupom_selecionado_matricula(new_id){
            this.configuracao_evento_matricula.evento_desconto_id = this.idInternoEvento(this.configuracao_unidade_matricula.lista_eventos_desconto, new_id)
        },
        id_evento_desc_geral_selecionado_matricula(new_id){
            this.configuracao_evento_matricula.evento_desconto_geral_id = this.idInternoEvento(this.configuracao_unidade_matricula.lista_eventos_desconto, new_id)
        },
        id_eventoselecionado_matricula(new_id){
            this.configuracao_evento_matricula.evento_id = this.idInternoEvento(this.configuracao_unidade_matricula.lista_eventos, new_id)
        },
        codigotipoparcela_inscricao_selecionado(new_id){
            this.configuracao_unidade_inscricao.codigotipoparcela = new_id
        },
        codigotipoparcela_matricula_selecionado(new_id){
            this.configuracao_unidade_matricula.codigotipoparcela = new_id
        },
        codigosituacaoparcela_inscricao_selecionado(new_id){
            this.configuracao_unidade_inscricao.codigosituacaoparcela = new_id
        },
        codigobancoconta_inscricao_selecionado(new_id){
            this.configuracao_unidade_inscricao.codigobancoconta = new_id
        },
        codigosituacaoparcela_matricula_selecionado(new_id){
            this.configuracao_unidade_matricula.codigosituacaoparcela = new_id
        },
        codigobancoconta_matricula_selecionado(new_id){
            this.configuracao_unidade_matricula.codigobancoconta = new_id
        },
    },
    methods:{
        // ----- listas e eventos --------------------------------------------------
        // lista do ERP/CRM (array ou objeto indexado); texto = mensagem de erro da consulta
        lista(valor){
            if(Array.isArray(valor)) return valor
            return valor && typeof valor === 'object' ? Object.values(valor) : []
        },
        // valor salvo que não está na lista (lista indisponível ou item removido do ERP/CRM)
        foraDaLista(listaValores, valor, campo){
            if(!valor || valor == 0) return false
            return !this.lista(listaValores).some(item => String(item[campo]) === String(valor))
        },
        // id interno (tabela de eventos) a partir do idevento do ERP escolhido no select
        idInternoEvento(listaEventos, idevento){
            if(!idevento || idevento == 0) return 0
            const evento = this.lista(listaEventos).find(e => parseInt(e.idevento) == idevento)
            return evento ? evento.id : 0
        },
        combinaBusca(evento, busca){
            const termo = this.normalizar(busca)
            return !termo || this.normalizar(evento.descricaoevento + ' ' + evento.idevento).includes(termo)
        },
        // eventos do grupo (optgroup) que combinam com a busca; o selecionado sempre fica na lista
        eventosDoGrupo(listaEventos, grupo, busca, selecionado){
            return this.lista(listaEventos).filter(evento => evento.descricaotipoevento==grupo.descricaotipoevento &&
                (this.combinaBusca(evento, busca) || evento.idevento == selecionado))
        },
        gruposVisiveis(grupos, listaEventos, busca, selecionado){
            return this.lista(grupos).filter(grupo => this.eventosDoGrupo(listaEventos, grupo, busca, selecionado).length > 0)
        },
        totalEventosEncontrados(busca){
            const todos = this.lista(this.configuracao_unidade_inscricao.lista_eventos).concat(this.lista(this.configuracao_unidade_inscricao.lista_eventos_desconto))
            return todos.filter(evento => this.combinaBusca(evento, busca)).length
        },
        normalizar(texto){
            return String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
        },
        semHtml(texto){
            return String(texto || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
        },

        // ----- situação das seções ------------------------------------------------
        valoresSecao(secao){
            const v = {
                valor:             [this.tipo_evento_aviso_valor_matricula_selecionado, this.custom_field_selecionado, this.etapa_selecionada],
                matriculaInscrito: [this.tipo_evento_aviso_matricula_selecionado, this.custom_field_matricula_selecionado, this.etapa_matricula_selecionada],
                parcelaInsc:       [this.codigotipoparcela_inscricao_selecionado, this.codigosituacaoparcela_inscricao_selecionado, this.codigobancoconta_inscricao_selecionado],
                eventosInsc:       [this.id_eventoselecionado_inscricao, this.id_evento_desc_selecionado_inscricao, this.id_evento_desc_servico_inscricao],
                parcelaMat:        [this.codigotipoparcela_matricula_selecionado, this.codigosituacaoparcela_matricula_selecionado, this.codigobancoconta_matricula_selecionado],
                eventosMat:        [this.id_eventoselecionado_matricula, this.id_evento_desc_cupom_selecionado_matricula, this.id_evento_desc_geral_selecionado_matricula, this.id_evento_desc_servico_matricula],
            }[secao]
            return v.map(x => (x === null || x === undefined || x === '' ? '0' : String(x)))
        },
        marcarSalvo(secao){
            this.$set(this.salvo, secao, this.valoresSecao(secao))
        },
        alterada(secao){
            const salvo = this.salvo[secao]
            return !!salvo && this.valoresSecao(secao).join('|') !== salvo.join('|')
        },
        abaAlterada(aba){
            return aba.secoes.some(secao => this.alterada(secao))
        },
        // volta a seção para os valores gravados
        desfazer(secao){
            const s = this.salvo[secao]
            const campos = {
                valor:             ['tipo_evento_aviso_valor_matricula_selecionado', 'custom_field_selecionado', 'etapa_selecionada'],
                matriculaInscrito: ['tipo_evento_aviso_matricula_selecionado', 'custom_field_matricula_selecionado', 'etapa_matricula_selecionada'],
                parcelaInsc:       ['codigotipoparcela_inscricao_selecionado', 'codigosituacaoparcela_inscricao_selecionado', 'codigobancoconta_inscricao_selecionado'],
                eventosInsc:       ['id_eventoselecionado_inscricao', 'id_evento_desc_selecionado_inscricao', 'id_evento_desc_servico_inscricao'],
                parcelaMat:        ['codigotipoparcela_matricula_selecionado', 'codigosituacaoparcela_matricula_selecionado', 'codigobancoconta_matricula_selecionado'],
                eventosMat:        ['id_eventoselecionado_matricula', 'id_evento_desc_cupom_selecionado_matricula', 'id_evento_desc_geral_selecionado_matricula', 'id_evento_desc_servico_matricula'],
            }[secao]
            campos.forEach((campo, i) => {
                // mantém o tipo original (números como número; etapa é texto)
                this[campo] = /^\d+$/.test(s[i]) ? parseInt(s[i], 10) : s[i]
            })
        },
        falta(valor){
            return !valor || valor == 0
        },
        pendencias(secao){
            const p = []
            const exigir = (valor, rotulo) => { if(this.falta(valor)) p.push(rotulo) }
            if(secao === 'valor'){
                exigir(this.tipo_evento_aviso_valor_matricula_selecionado, 'tipo de evento')
                exigir(this.custom_field_selecionado, 'campo personalizado')
                exigir(this.etapa_selecionada, 'etapa')
            }else if(secao === 'matriculaInscrito'){
                exigir(this.tipo_evento_aviso_matricula_selecionado, 'tipo de evento')
                exigir(this.custom_field_matricula_selecionado, 'campo personalizado')
                exigir(this.etapa_matricula_selecionada, 'etapa')
            }else if(secao === 'parcelaInsc' || secao === 'parcelaMat'){
                const insc = secao === 'parcelaInsc'
                exigir(insc ? this.codigotipoparcela_inscricao_selecionado : this.codigotipoparcela_matricula_selecionado, 'tipo de parcela')
                exigir(insc ? this.codigosituacaoparcela_inscricao_selecionado : this.codigosituacaoparcela_matricula_selecionado, 'situação')
                exigir(insc ? this.codigobancoconta_inscricao_selecionado : this.codigobancoconta_matricula_selecionado, 'conta bancária')
            }else if(secao === 'eventosInsc'){
                exigir(this.id_eventoselecionado_inscricao, 'evento')
                if(!this.configuracao_unidade_inscricao.eventos_configurados.length && !p.length) p.push('salvar os eventos')
            }else if(secao === 'eventosMat'){
                exigir(this.id_eventoselecionado_matricula, 'evento')
                if(!this.configuracao_unidade_matricula.eventos_configurados.length && !p.length) p.push('salvar os eventos')
            }
            return p
        },
        pendenciasAba(aba){
            return aba.secoes.reduce((todas, secao) => todas.concat(this.pendencias(secao)), [])
        },

        // ----- abas e saída da página --------------------------------------------
        antesDeTrocarAba(e){
            if(this.trocandoAba) return
            const atual = this.abas.find(a => '#' + a.id === (e.relatedTarget && e.relatedTarget.getAttribute('href')))
            if(!atual || !this.abaAlterada(atual)) return
            e.preventDefault()
            const destino = e.target
            this.$bvModal.msgBoxConfirm('A aba "' + atual.titulo + '" tem alterações que ainda não foram salvas. Elas continuam na tela, mas só valem depois de salvar.', {
                title: 'Alterações não salvas',
                okTitle: 'Trocar de aba',
                cancelTitle: 'Continuar editando',
                okVariant: 'primary',
                cancelVariant: 'outline-secondary',
                centered: true,
                footerClass: 'p-2',
            }).then(confirmado => {
                if(!confirmado) return
                this.trocandoAba = true
                $(destino).tab('show')
                this.trocandoAba = false
            })
        },
        // "há 5 min", "às 14:32 de 07/10"
        quando(dataIso){
            const data = new Date(dataIso)
            const minutos = Math.round((Date.now() - data.getTime()) / 60000)
            if(minutos < 1) return 'agora há pouco'
            if(minutos < 60) return 'há ' + minutos + ' min'
            return 'às ' + data.toLocaleTimeString('pt-BR', { hour:'2-digit', minute:'2-digit' }) + ' de ' + data.toLocaleDateString('pt-BR', { day:'2-digit', month:'2-digit' })
        },

        // ----- mensagens ---------------------------------------------------------
        avisar(mensagem, variante = 'success'){
            this.$bvToast.toast(mensagem, {
                title: variante === 'danger' ? 'Algo deu errado' : 'Tudo certo',
                variant: variante,
                solid: true,
                toaster: 'b-toaster-bottom-right',
                autoHideDelay: variante === 'danger' ? 8000 : 4000,
            })
        },
        mensagemErro(erro, padrao){
            const dados = erro && erro.response && erro.response.data
            const texto = dados && (dados.mensagem || dados.message)
            return this.semHtml(texto) || padrao || 'Não foi possível salvar. Verifique a conexão e tente novamente.'
        },
        // salva uma seção: indicador no botão, aviso de sucesso/erro e marca como gravada
        async salvarSecao(secao, requisicao, aoSalvar, mensagemSucesso){
            this.$set(this.salvando, secao, true)
            try{
                const response = await requisicao()
                if(aoSalvar) aoSalvar(response.data)
                this.marcarSalvo(secao)
                this.avisar(mensagemSucesso)
            }catch(erro){
                console.log(erro)
                this.avisar(this.mensagemErro(erro), 'danger')
            }finally{
                this.$set(this.salvando, secao, false)
            }
        },
        urlEvento(setFinancesId, sufixo){
            return window.location.origin + '/api/v1/Finances/Unity/Unitie/' + this.unidade.id + '/Event' + (setFinancesId ? '/' + setFinancesId : '') + (sufixo || '')
        },
        formulario(campos){
            const formData = new FormData()
            Object.keys(campos).forEach(chave => formData.append(chave, campos[chave]))
            return formData
        },

        // ----- ações -------------------------------------------------------------
        // botão do cabeçalho: eventos e demais listas do ERP/CRM ao mesmo tempo
        sincronizarTudo(){
            return Promise.all([this.getListaEventos(true), this.atualizarListas(true, true)])
                .then(([eventos, listas]) => {
                    if(eventos && listas) this.avisar('Listas sincronizadas com o ERP/CRM.')
                })
        },
        // listas do ERP/CRM (tipos/situações de parcela, contas, tipos de evento, campos);
        // forcar = sincroniza mesmo que a última sincronização seja recente
        atualizarListas(forcar, silencioso){
            this.atualizandoListas = true
            return axios.get(window.location.origin + '/api/v1/Finances/Unity/Unitie/' + this.unidade.id + '/listas', { params: { forcar: forcar ? 1 : 0 } })
                .then(response => {
                    const dados = response.data
                    for(const lista in LISTAS_SINCRONIZADAS){
                        if(!(lista in dados)) continue
                        for(const bloco of LISTAS_SINCRONIZADAS[lista]) this.$set(this.configuracao[bloco], lista, dados[lista])
                    }
                    this.errosIntegracao = dados.erros || {}
                    this.sincronizadoEm = dados.sincronizado_em || this.sincronizadoEm
                    const falhou = Object.keys(this.errosIntegracao).length > 0
                    if(forcar && !silencioso){
                        this.avisar(falhou ? 'Algumas listas não puderam ser atualizadas; veja o aviso no topo.' : 'Listas atualizadas com o ERP/CRM.', falhou ? 'danger' : 'success')
                    }
                    return !falhou
                })
                .catch(erro => {
                    console.log(erro)
                    if(forcar) this.avisar(this.mensagemErro(erro, 'Não foi possível atualizar as listas do ERP/CRM.'), 'danger')
                    return false
                })
                .finally(() => { this.atualizandoListas = false })
        },
        getListaEventos(silencioso){
            this.sincronizando = true
            return axios.get(window.location.origin + '/api/v1/Erp/ListaEventos/' + this.unidade.id)
                .then(response => {
                    this.configuracao_unidade_inscricao.lista_eventos = response.data.lista_eventos
                    this.configuracao_unidade_inscricao.lista_eventos_desconto = response.data.lista_eventos_desconto
                    this.configuracao_unidade_matricula.lista_eventos = response.data.lista_eventos
                    this.configuracao_unidade_matricula.lista_eventos_desconto = response.data.lista_eventos_desconto
                    const total = this.lista(response.data.lista_eventos).length
                    if(Array.isArray(response.data.lista_eventos)){
                        if(!silencioso) this.avisar('Eventos sincronizados com o ERP: ' + total + ' evento(s) disponível(is).')
                        return true
                    }
                    this.avisar('O ERP não devolveu a lista de eventos: ' + (this.semHtml(response.data.lista_eventos) || 'resposta vazia') + '.', 'danger')
                    return false
                })
                .catch(erro => {
                    console.log(erro)
                    this.avisar(this.mensagemErro(erro, 'Não foi possível sincronizar os eventos com o ERP.'), 'danger')
                    return false
                })
                .finally(() => { this.sincronizando = false })
        },
        salvarConfiguracaoDisparoEventoCRM(){
            return this.salvarSecao('valor',
                () => axios.post(this.urlEvento(this.configuracao_evento_inscricao.set_finances_unitie_id, '/update_tipoevento'), this.formulario({
                    codigotipoevento: this.tipo_evento_aviso_valor_matricula_selecionado,
                    id_custom_field: this.custom_field_selecionado,
                    etapa: this.etapa_selecionada,
                })),
                dados => {
                    this.tipo_evento_aviso_valor_matricula_selecionado = dados.configuracao.tipoeventoavisovalormatricula
                    this.custom_field_selecionado = dados.configuracao.custom_field_id
                },
                'Disparo do evento "valor da matrícula" salvo.')
        },
        salvarConfiguracaoDisparoEventoMatriculaCRM(){
            return this.salvarSecao('matriculaInscrito',
                () => axios.post(this.urlEvento(this.configuracao_evento_inscricao.set_finances_unitie_id, '/update_tipoevento_matricula'), this.formulario({
                    codigotipoevento: this.tipo_evento_aviso_matricula_selecionado,
                    id_custom_field: this.custom_field_matricula_selecionado,
                    etapa: this.etapa_matricula_selecionada,
                })),
                dados => {
                    // antes a resposta ia para o select do "valor da matrícula" (bloco de cima)
                    this.tipo_evento_aviso_matricula_selecionado = dados.configuracao.tipoeventoavisomatriculainscrito
                    this.custom_field_matricula_selecionado = dados.configuracao.custom_field_matricula_id
                },
                'Disparo do evento de matrícula do inscrito salvo.')
        },
        salvarCodigoTipoParcelaInscricao(){
            return this.salvarSecao('parcelaInsc',
                () => axios.post(this.urlEvento(this.configuracao_evento_inscricao.set_finances_unitie_id, '/update'), this.formulario({
                    codigotipoparcela: this.codigotipoparcela_inscricao_selecionado,
                    codigosituacaoparcela: this.codigosituacaoparcela_inscricao_selecionado,
                    codigobancoconta: this.codigobancoconta_inscricao_selecionado,
                })),
                dados => { this.codigotipoparcela_inscricao_selecionado = dados.configuracao.codigotipoparcela },
                'Parcela da taxa de inscrição salva.')
        },
        salvarCodigoTipoParcelaMatricula(){
            return this.salvarSecao('parcelaMat',
                () => axios.post(this.urlEvento(this.configuracao_evento_matricula.set_finances_unitie_id, '/update'), this.formulario({
                    codigotipoparcela: this.codigotipoparcela_matricula_selecionado,
                    codigosituacaoparcela: this.codigosituacaoparcela_matricula_selecionado,
                    codigobancoconta: this.codigobancoconta_matricula_selecionado,
                })),
                dados => { this.codigotipoparcela_matricula_selecionado = dados.configuracao.codigotipoparcela },
                'Parcela da taxa de matrícula salva.')
        },
        adicionarEventoConfUnidadeInscricao(){
            return this.salvarSecao('eventosInsc',
                () => axios.post(this.urlEvento(null), this.formulario({ dados_evento_adicionar: JSON.stringify(this.configuracao_evento_inscricao) })),
                dados => {
                    this.configuracao_unidade_inscricao.lista_eventos = dados.lista_eventos
                    this.configuracao_unidade_inscricao.lista_eventos_desconto = dados.lista_eventos_desconto
                    this.configuracao_unidade_inscricao.eventos_configurados = dados.eventos_configurados
                    const configurado = dados.eventos_configurados[0] || {}
                    this.id_eventoselecionado_inscricao = configurado.event ? configurado.event.idevento : 0
                    this.id_evento_desc_selecionado_inscricao = configurado.event_discount ? configurado.event_discount.idevento : 0
                    this.id_evento_desc_servico_inscricao = configurado.event_service ? configurado.event_service.idevento : 0
                },
                'Eventos da taxa de inscrição salvos.')
        },
        adicionarEventoConfUnidadeMatricula(){
            return this.salvarSecao('eventosMat',
                () => axios.post(this.urlEvento(null), this.formulario({ dados_evento_adicionar: JSON.stringify(this.configuracao_evento_matricula) })),
                dados => {
                    this.configuracao_unidade_matricula.lista_eventos = dados.lista_eventos
                    this.configuracao_unidade_matricula.lista_eventos_desconto = dados.lista_eventos_desconto
                    this.configuracao_unidade_matricula.eventos_configurados = dados.eventos_configurados
                    const configurado = dados.eventos_configurados[0] || {}
                    this.id_eventoselecionado_matricula = configurado.event ? configurado.event.idevento : 0
                    this.id_evento_desc_cupom_selecionado_matricula = configurado.event_discount ? configurado.event_discount.idevento : 0
                    this.id_evento_desc_geral_selecionado_matricula = configurado.event_discount_geral ? configurado.event_discount_geral.idevento : 0
                    this.id_evento_desc_servico_matricula = configurado.event_service ? configurado.event_service.idevento : 0
                },
                'Eventos da taxa de matrícula salvos.')
        },
        // remove (com confirmação) todos os eventos configurados da parcela
        async removerEventos(secao, configuracaoUnidade, configuracaoEvento, resetar, nome){
            const confirmado = await this.$bvModal.msgBoxConfirm('Os eventos configurados para a ' + nome + ' serão removidos. Até configurar novos eventos, essa parcela não terá eventos ao enviar ao ERP.', {
                title: 'Remover eventos?',
                okTitle: 'Remover',
                cancelTitle: 'Cancelar',
                okVariant: 'danger',
                cancelVariant: 'outline-secondary',
                centered: true,
                footerClass: 'p-2',
            })
            if(!confirmado) return

            this.$set(this.salvando, secao, true)
            try{
                for(const evento of configuracaoUnidade.eventos_configurados.slice()){
                    configuracaoEvento.set_finances_unitie_id = evento.set_finances_unitie_id
                    configuracaoEvento.evento_id = evento.event_id
                    const response = await axios.post(this.urlEvento(configuracaoEvento.set_finances_unitie_id), this.formulario({ dados_evento_remover: JSON.stringify(configuracaoEvento) }))
                    configuracaoUnidade.lista_eventos = response.data.lista_eventos
                    configuracaoUnidade.lista_eventos_desconto = response.data.lista_eventos_desconto
                    configuracaoUnidade.eventos_configurados = response.data.eventos_configurados
                }
                resetar()
                this.marcarSalvo(secao)
                this.avisar('Eventos da ' + nome + ' removidos.')
            }catch(erro){
                console.log(erro)
                this.avisar(this.mensagemErro(erro, 'Não foi possível remover os eventos.'), 'danger')
            }finally{
                this.$set(this.salvando, secao, false)
            }
        },
        removerEventosInscricao(){
            return this.removerEventos('eventosInsc', this.configuracao_unidade_inscricao, this.configuracao_evento_inscricao, this.resetarDadosEventosInscricao, 'taxa de inscrição')
        },
        removerEventosMatricula(){
            return this.removerEventos('eventosMat', this.configuracao_unidade_matricula, this.configuracao_evento_matricula, this.resetarDadosEventosMatricula, 'taxa de matrícula')
        },
        resetarDadosEventosInscricao(){
            this.id_eventoselecionado_inscricao = 0;
            this.configuracao_evento_inscricao.evento_id = null
            this.configuracao_evento_inscricao.valor = 0.00

            this.id_evento_desc_selecionado_inscricao = 0;
            this.id_evento_desc_servico_inscricao = 0;
            this.configuracao_evento_inscricao.evento_desconto_id = null
            this.configuracao_evento_inscricao.evento_servico_id = null
        },
        resetarDadosEventosMatricula(){
            this.id_eventoselecionado_matricula = 0;
            this.configuracao_evento_matricula.evento_id = null
            this.configuracao_evento_matricula.valor = 0.00

            this.id_evento_desc_cupom_selecionado_matricula = 0;
            this.configuracao_evento_matricula.evento_desconto_id = null
            this.configuracao_evento_matricula.evento_servico_id = null

            this.id_evento_desc_geral_selecionado_matricula = 0;
            this.id_evento_desc_servico_matricula = 0;
            this.configuracao_evento_matricula.evento_desconto_geral_id = null
        },
    }
}
</script>

<style scoped>

    .cf-cabecalho {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        gap: .75rem;
        margin-bottom: 1rem;
    }

    .cf-cabecalho__titulo { margin: 0 0 .2rem; font-size: 1.25rem; }

    .cf-cabecalho__acoes {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: .3rem;
    }

    .cf-cabecalho__sincronia {
        display: inline-flex;
        align-items: center;
        gap: .35rem;
        color: #64767c;
    }
    .cf-cabecalho__sub { margin: 0; font-size: .85rem; color: #64767c; }

    /* aviso de listas que não vieram do ERP/CRM */
    .cf-alerta {
        display: flex;
        align-items: flex-start;
        gap: .75rem;
        margin-bottom: 1rem;
        padding: .85rem 1rem;
        border: 1px solid #f5c2c0;
        border-left: 4px solid #b42318;
        border-radius: .5rem;
        background: #fff5f4;
        color: #5c1a14;
        font-size: .875rem;
    }

    .cf-alerta__icone { flex: 0 0 auto; margin-top: .15rem; color: #b42318; font-size: 1.1rem; }
    .cf-alerta__texto { flex: 1 1 auto; min-width: 0; }
    .cf-alerta__lista { margin: .35rem 0 .35rem 1rem; padding: 0; }
    .cf-alerta__erro { color: #7a2a22; font-family: SFMono-Regular, Menlo, Consolas, monospace; font-size: .78rem; word-break: break-word; }
    .cf-alerta__acao { flex: 0 0 auto; white-space: nowrap; }

    /* situação de cada aba */
    .nav-link { display: inline-flex; align-items: center; gap: .35rem; }

    .cf-aba-selo {
        min-width: 1.15rem;
        padding: 0 .3rem;
        border-radius: 999px;
        font-size: .68rem;
        font-weight: 700;
        line-height: 1.15rem;
        text-align: center;
    }

    .cf-aba-selo--pendente { background: #fff3d6; color: #8a5a00; }
    .cf-aba-ok { color: #2e9e6b; font-size: .8rem; }

    .cf-aba-alterada {
        width: .45rem;
        height: .45rem;
        border-radius: 50%;
        background: #e8590c;
    }

    .cf-acoes-secao {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        gap: .5rem;
        margin: 0 0 1rem;
    }

    .cf-situacao {
        display: inline-flex;
        align-items: center;
        gap: .35rem;
        margin-right: auto;
        font-size: .8rem;
        font-weight: 600;
    }

    .cf-situacao--ok { color: #2e9e6b; }
    .cf-situacao--pendente { color: #8a5a00; }
    .cf-situacao--alterada { color: #c2410c; }

    /* busca nas listas de eventos */
    .cf-busca-eventos {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: .5rem;
        max-width: 32rem;
        margin-bottom: .85rem;
    }

    .cf-busca-eventos input { flex: 1 1 16rem; padding-left: 2rem; }
    .cf-busca-eventos__icone { position: absolute; left: .65rem; top: .55rem; color: #64767c; pointer-events: none; }
    .cf-busca-eventos__info { color: #64767c; }

    /* número do passo no título da seção */
    .cf-passo {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.35rem;
        height: 1.35rem;
        border-radius: 50%;
        background: #1c4d5a;
        color: #fff;
        font-size: .7rem;
    }

    fieldset:disabled .ec-form-secao__descricao { font-style: italic; }

    /* campo obrigatório vazio: borda de aviso */
    .custom-select.cf-faltando { border-color: #e0a63b; }
    .custom-select.cf-faltando:focus { box-shadow: 0 0 0 .2rem rgba(224, 166, 59, .25); }

</style>
